module.exports = __webpack_public_path__ + "static/media/nu10.b60863c3.webp";